module.exports = __webpack_public_path__ + "img/03.2fa1283f.png";